enum LeadQuerySortDirectionEnum {
  Ascending = 1,
  Descending = -1,
}

export default LeadQuerySortDirectionEnum;
